import { ConcreteEncodable } from "./ConcreteEncodable";

import { BroadcastMessEventImplEncoder } from "../../encoder/BroadcastMessEventImplEncoder";

import * as CubiqTS from "../../index";
import { BroadcastMessEvent } from "../BroadcastMessEvent";

export class BroadcastMessEventImpl extends ConcreteEncodable implements BroadcastMessEvent {
  public static enType: string = "com.bcdfx.model.event.BroadcastMessEventImpl";

  /*FID=1*/
  public message: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = BroadcastMessEventImplEncoder.Instance;
    this.setEncodableType(BroadcastMessEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "BroadcastMessEventImpl[" + "message=" + this.message + "messageId=" + this.messageId + "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
